import React, { PureComponent } from "react";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  Container,
  Row,
  Modal,
  Table,
  Tooltip,
} from "reactstrap";
import { Field, reduxForm } from "redux-form";
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';


import 'react-accessible-accordion/dist/fancy-example.css';
import { faSyncAlt } from "@fortawesome/free-solid-svg-icons";


import EyeIcon from "mdi-react/EyeIcon";
import EmailIcon from "mdi-react/EmailIcon";
import AccountSearchIcon from "mdi-react/AccountSearchIcon";
import DatePicker from "react-datepicker";

//import Select from "react-dropdown-select";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import renderFileInputField from "../../../../shared/components/form/FileInput";
import renderSelectField from "../../../../shared/components/form/Select";
import renderMultiSelectField from "../../../../shared/components/form/MultiSelect";
import $ from "jquery";
import readXlsxFile from "read-excel-file";
//import Util from "../../../Common/util";
import XLSX from "xlsx";
import Sheet from "../../../../images/BIN_MASTER_v1.xlsx";
import axios from "axios";
import { MDBDataTable } from "mdbreact";
//import API from "../../../Common/api";
import _ from "lodash";
import "./styles.css";
import LoadingOverlay from "react-loading-overlay";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import Util from '../../../Common/util';
import API from '../../../Common/api';
//import styled, { css } from "styled-components";
import { useMemo, useState } from 'react';
import { useTable, usePagination, useGlobalFilter, useSortBy, useRowSelect } from 'react-table';
import { useAsyncDebounce } from 'react-table';
import { Checkbox } from '../../../Maintenance/StockTransfer/components/Checkbox'
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';



var url = window.location.hostname;
var port = window.location.port;
var data_img = [];
var assign_arr= [];
var unassign_arr = [];
var data_type = "";
var From_Date_val;
var to_Date_val;

class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();

    this.getCookie = this.getCookie.bind(this);
    this.createCookie = this.createCookie.bind(this);
    this.onApply = this.onApply.bind(this);
    this.onApplyData = this.onApplyData.bind(this);
    this.accessCookie = this.accessCookie.bind(this);
    this.toggle = this.toggle.bind(this);
    this.accessCookie = this.accessCookie.bind(this);
    this.SuccessConfirmtoggle = this.SuccessConfirmtoggle.bind(this);
    this.SuccessConfirmtoggle1 = this.SuccessConfirmtoggle1.bind(this);
    this.SuccessConfirmtoggle2 = this.SuccessConfirmtoggle2.bind(this);
    this.SuccessConfirmoktoggle = this.SuccessConfirmoktoggle.bind(this);
    this.handleChangeVanVal = this.handleChangeVanVal.bind(this);
    this.handleChangeVan1Val = this.handleChangeVan1Val.bind(this);

    this.changeEAN = this.changeEAN.bind(this);
    this.getStoreList = this.getStoreList.bind(this);
    this.getSubGroupStoreList = this.getSubGroupStoreList.bind(this);
    this.getTaskList = this.getTaskList.bind(this);
    this.getMCCode = this.getMCCode.bind(this);
    this.getTaskTypeList = this.getTaskTypeList.bind(this);
    this.UnAssign = this.UnAssign.bind(this);
    this.assignedOrdersList = this.assignedOrdersList.bind(this);
    this.Assign = this.Assign.bind(this);
    this.OpenAssign = this.OpenAssign.bind(this);
    this.toggleOK = this.toggleOK.bind(this);
    this.toggleOKNew = this.toggleOKNew.bind(this);
    this.toggleNew = this.toggleNew.bind(this);


    this.toggle1 = this.toggle1.bind(this);
    this.changeArticleId = this.changeArticleId.bind(this);
    this.onGroupNameChange = this.onGroupNameChange.bind(this);
    this.toggleNPICancel = this.toggleNPICancel.bind(this);
    this.toggle2 = this.toggle2.bind(this);
    this.onConfirm = this.onConfirm.bind(this);
    this.onConfirmProduct = this.onConfirmProduct.bind(this);
    this.viewImage = this.viewImage.bind(this);
    this.onApply2 = this.onApply2.bind(this);
    this.changeLongName = this.changeLongName.bind(this);
    this.changeShortName = this.changeShortName.bind(this);
    this.changeDesc = this.changeDesc.bind(this);
    this.changeMargin = this.changeMargin.bind(this);
    this.changeItemType = this.changeItemType.bind(this);
    this.changeCostPrice = this.changeCostPrice.bind(this);
    this.changeSellingPrice = this.changeSellingPrice.bind(this);
    this.changeHSNCode = this.changeHSNCode.bind(this);
    this.ChangeLocation = this.ChangeLocation.bind(this);
    this.ChangeLocation = this.ChangeLocation.bind(this);
    this.ChangeOutlet = this.ChangeOutlet.bind(this);
    this.AssignData = this.AssignData.bind(this);
    this.AssignData1 = this.AssignData1.bind(this);
    
    this.Failedtoggle = this.Failedtoggle.bind(this);
    this.getVanList = this.getVanList.bind(this);
    this.toggleTooltip = this.toggleTooltip.bind(this);


    /*this.ExcelDateToJSDate = this.ExcelDateToJSDate.bind(this);*/
    /*this.toShortFormat = this.toShortFormat.bind(this);*/
    this.state = {
      orderdata: [],
      variant_data: [],
      arr_data1: [],
      shelf_life_uom: [],
      ShowpopupLoader: false,
      totalTonnage: 0,
      totalWeightVal: 0,
      total_cld:0,
      total_loose:0,
      modalNew: false,
      createDisabled: false,
      tooltipOpen: false,
      showCreatedId: false,
      showFilter: false,
      ShowConfirmLoader: false,
      totalBillVal: 0,
      selectedVan1: "",
      reviewErr: "",
      selectedLocation1: "",
      isChecked1: false,
      showSelectGroup: false,
      showNewGroup: false,
      unAssignOrder: [],
      van_list: [],
      assignOrder: [],
      isDisabledSearch: false,
      autoDesc: "",
      selectedDistributor: "",
      isChecked: false,
      autoLongName: "",
      autoShortName: "",
      showConfirmError: false,
      selectedVan: "",
      autoCostPrice: "",
      autoSellingPrice: "",
      stationData: [],
      zoneData: [],
      reviewData: [],
      group_id: "",
      autoHsnCode: "",
      selectedOutlet: "",
      selectedDistributor: "",
      selectedLocation: "",
      selectedOrder: "",
      autoDesc: "",
      autoMargin: "",
      autoItemtype: "",
      article_id: "",
      mc_code_data: [],
      pack_size_uom: [],
      updated_fields: [],
      FailedModal: false,
      order: [],
      row_data: [],
      arr_data: [],
      Polaris: [],
      task_type: [],
      pack_size1: [],
      variant1: [],
      task: [],
      store: [],
      distributor:[],
      areaCode:[],
      location: [],
      EditModal: false,
      selectedVanFilter: "",
      fromdate: "",
      todate: "",
      hsn_value: "",
      loader1: false,
      showVariant: false,
      isDisabledApply: false,
      mc_code: false,
      hsn_code: [],
      applyPackSize: "",
      mc_error: false,
      showTable: false,
      subGroupList:"",
      color_variant: false,
      applyShelfLife: "",
      applyPackUOM: "",
      applyShelfUOM: "",
      applyTax: "",
      applyVariant: "",
      color_mrp: false,
      color_shelf: false,
      color_mc_code: false,
      color_brand: false,
      color_tax: false,
      assignLoader: false,
      assignDisabled: true,
      color_ean: false,
      color_product: false,
      product_name_val: "",
      applyMrp: "",
      status_type: "1",
      apply: true,
      store_id: "",
      task_id: "",
      polaris_id: "",
      task_type_value: "",
      request_id: "",
      taskId: "",
      packSize: "",
      constantmrp: "",
      showUnAssignedOrder: false,
      SuccessConfirmmodal1: false,
      SuccessConfirmmodal2:false,
      longName: "",
      brand: "",
      mrp: "",
      ean: "",
      variant: "",
      shelf_life: "",
      //showCreatedId: false,
      image1: "",
      image2: "",
      image3: "",
      image4: "",
      image5: "",
      groupName: "",
      pack_unit: "",
      shelf_unit: "",
      showFetchDispatchData: false,

      disabledBtn: false,
      showData: false,
      showErrorMessage: false,
      product_id: null,
      brand_value: "",
      mc_code_value: "",

      apply1: true,
      total_value: "",
      total_quantity: "",

      shelf_life_data: [],
      modal: false,
      selectedGroup: "",
      selectedSubGroup:"",
      weight: "",
      volume: "",
      bill_number: "",
      bill_range: "",
      bill_value: "",
      pl_group: "",
      area_code: "",
      modal1: false,
      modal2: false,
      modalFailed: false,
      showPackSize: false,
      showShelfLife: false,
      color_packSize: false,
      new_brand: "",
      new_pack_size: "",
      new_shelf_life: "",
      new_tax_percentage: "",
      failed_message: "",
      new_variant: "",
      showAllItem: false,
      disabledReasonBtn: true,
      showInvalidItem: false,
      showProceedbtn: false,
      showReasonbtn: false,
      reasonCodeNeeded: false,
      SuccessConfirmmodal: false,
      modalReason: false,
      loadingconfirmbtn: false,
      autoVariant: "",
      autoPackSize: "",
      autoProductName: "",
      autoShelfLife: "",
      loading: false,
      loading_overlay: false,
      url: window.location.hostname,
      port: window.location.port,
      prod_arr : []
    };
  }

  Assign(){
      this.fetchDispatch();


  }

  onGroupNameChange(e){
    this.setState({
      groupName: e.target.value
    })
  }

  toggleTooltip(){
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    });
  }

  UnAssign(){
      this.setState({
       
        loading_overlay: true,

      })
      const payload = {
        location: this.state.selectedLocation,
  };

API.post('/product/product_master/v1/orders/', { param: payload })
      .then((response) => {
      
       this.setState({
         showUnAssignedOrder: false,
        showAssignedOrder: true,
        unAssignOrder: response.data.data.unassigned_orders,
        assignOrder: response.data.data.assigned_orders,
        loading_overlay: false,

       })
      })
      .catch(function(error) {});

  }



  assignedOrdersList(){

     const payload = {
      location: this.state.selectedLocation,
  };

API.post('/product/product_master/v1/orders/', { param: payload })
      .then((response) => {
  
       this.setState({
        unAssignOrder: response.data.data.unassigned_orders,
        assignOrder: response.data.data.assigned_orders

       })
      })
      .catch(function(error) {});

  }

  ChangeStation(evt, index) {
    const {reviewData} = this.state;
    var Station = evt.target.value
    reviewData[index]['station'] = Station

    this.setState({
      reviewData: reviewData
    })


  };

  ChangeZone(evt, index) {
    const {reviewData} = this.state;
    var Zone = evt.target.value
    reviewData[index]['zone'] = Zone

    this.setState({
      reviewData: reviewData
    })


  };

  changeBrand = (evt) => {
    this.setState({
      brand_value: evt.target.value,
      brand: evt.target.value,
    });
  };
  changeArticleId = (evt) => {
    this.setState({
      article_id: evt.target.value,
    });
  };

  changeLongName = (evt) => {
    this.setState({
      autoLongName: evt.target.value,
    });
  };

  changeEAN = (evt) => {
    this.setState({
      ean: evt.target.value,
    });
  };

  changeShortName = (evt) => {
    this.setState({
      autoShortName: evt.target.value,
    });
  };

  changeDesc = (evt) => {
    this.setState({
      autoDesc: evt.target.value,
    });
  };

  changeSellingPrice = (evt) => {
    this.setState({
      autoSellingPrice: evt.target.value,
    });
  };

  changeCostPrice = (evt) => {
    this.setState({
      autoCostPrice: evt.target.value,
    });
  };
  changeHSNCode = (evt) => {
    this.setState({
      autoHsnCode: evt.target.value,
    });
  };

  changeItemType = (evt) => {
    this.setState({
      autoItemtype: evt.target.value,
    });
  };

  changeMargin = (evt) => {
    this.setState({
      autoMargin: evt.target.value,
    });
  };

  viewImage() {
    //window.open('/view_image','_blank');
    this.props.history.push("/npi_request_data");
  }

  onApplyData() {
    this.setState({
      loader1: true,
      isDisabledApply: true,
    });

    if (
      (this.state.mc_code_value == "" ||
        this.state.mc_code_value == "undefined" ||
        this.state.mc_code_value == undefined) &&
      (this.state.article_id == "" ||
        this.state.article_id == "undefined" ||
        this.state.article_id == undefined)
    ) {
      this.setState({
        mc_error: true,
        loader1: false,
        isDisabledApply: false,
      });
      return false;
    } else {
      this.setState({
        mc_error: false,
      });
    }

    axios
      .post(
        "http://" + url + "/fms/stockcheck/v1/products/",

        {
          location: this.state.selectedLocation,
          mc_code: this.state.mc_code_value,
          //brand: this.state.brand_value,
          article_id: this.state.article_id,
          api_type: "hsn_code",
        },

        {
          headers: {
            "Content-Type": "application/json",
            //Authorization: Util.accessCookie("token"),
          },
        }
      )
      .then((response) => {
        this.setState({
          hsn_code: response.data.data,
        });
      })
      .catch(function(error) {});

    axios
      .post(
        "http://" + url + "/fms/stockcheck/v1/products/",

        {
          location: this.state.selectedLocation,
          mc_code: this.state.mc_code_value,
          //brand: this.state.brand_value,
          article_id: this.state.article_id,
          api_type: "pack_size",
        },

        {
          headers: {
            "Content-Type": "application/json",
            //Authorization: Util.accessCookie("token"),
          },
        }
      )
      .then((response) => {
        this.setState({
          pack_size1: response.data.data,
        });
      })
      .catch(function(error) {});

    axios
      .post(
        "http://" + url + "/fms/stockcheck/v1/products/",

        {
          location: this.state.selectedLocation,
          api_type: "variant",
          mc_code: this.state.mc_code_value,
          article_id: this.state.article_id,
          //brand: this.state.brand_value,
        },

        {
          headers: {
            "Content-Type": "application/json",
            //Authorization: Util.accessCookie("token"),
          },
        }
      )
      .then((response) => {
        this.setState({
          variant_data: response.data.data,
        });
      })
      .catch(function(error) {});

    axios
      .post(
        "http://" + url + "/fms/stockcheck/v1/products/",

        {
          location: this.state.selectedLocation,
          api_type: "shelf_life",
          mc_code: this.state.mc_code_value,
          article_id: this.state.article_id,
          //brand: this.state.brand_value,
        },

        {
          headers: {
            "Content-Type": "application/json",
            //Authorization: Util.accessCookie("token"),
          },
        }
      )
      .then((response) => {
        this.setState({
          shelf_life_data: response.data.data,
          //loader1: false,
          isDisabledApply: false,
        });
      })
      .catch(function(error) {});

    this.onApply();
  }

  changeMCCode = (evt) => {
    this.setState({
      mc_error: false,
      mc_code_value: evt.target.value,
    });
  };

  AssignData(){
    
    this.setState({
      assignLoader: true,
      assignDisabled: true
    })
    var arrayData = this.state.arr_data.filter(
      (item) => item.isChecked === true
    );

     var arr = [];

    for (var i = 0; i < arrayData.length; i++) {
      arr.push(arrayData[i].id);
    }
    var req_id = [];

  

    const payload = {
   
          van_id: this.state.selectedVan1,
          order_id: arr,
          group_id: this.state.selectedGroup,
          screen_type: "van_replanning_screen"
          //req_ids: req_id
  };
  addAnalytics('Trip Planning', 'Trip Planning Assign Van', payload);


API.post('/master_ptl/van/v1/assign/', { param: payload })
      .then((response) => {
        //alert(response.data.message);
        this.setState({
          variant1: response.data.data,
          loading_overlay: true,
          success_message: response.data.message,
          isChecked: false,
           totalBillVal: 0,
          totalTonnage: 0,
          totalWeightVal: 0,


          //SuccessConfirmmodal: false
        });
        if(response.data.success == true){
          this.toggle();
        }else{
        this.Failedtoggle();
        }
        this.setState({
        SuccessConfirmmodal: false,
        showCreatedId: false,
        showSelectGroup: false,
        showNewGroup: false,
        assignLoader: false,
        assignDisabled: false,
        createDisabled: false
        })
        
        this.getBillList();
      })
      .catch(function(error) {});

  }



  AssignData1(){
    this.setState({
      assignLoader1: true,
      assignDisabled1: true
    })
  
    var arrayData = this.state.arr_data1.filter(
      (item) => item.isChecked === true
    );

     var arr = [];
     var pl_arr = [];
     var order_id = [];

    for (var i = 0; i < arrayData.length; i++) {
      arr.push(arrayData[i].area_code);
      pl_arr.push(arrayData[i].pl_group);
      for(var j = 0; j< arrayData[i].orders.length ; j++){
        
        order_id.push(arrayData[i].orders[j]);
      }


    }
    
    var req_id = [];


    const payload = {
     
          order_id: order_id,
          van_id: this.state.selectedVan,
          area_code: arr,
          group_id: this.state.selectedGroup,
          pl_group: pl_arr,
          screen_type: "van_replanning_screen"
      
  };

API.post('/master_ptl/van/v1/assign/', { param: payload })
      .then((response) => {
      
        this.setState({
          variant1: response.data.data,
          loading_overlay: true,
          success_message: response.data.message,
          totalBillVal: 0,
          totalTonnage: 0,
          totalWeightVal: 0,

          //SuccessConfirmmodal: false
        });
        if(response.data.success == true){
          this.toggle();
        }else{
        this.Failedtoggle();
        }
        this.setState({
        SuccessConfirmmodal1: false,
        showCreatedId: false,
        showSelectGroup: false,
        showNewGroup: false,
        assignLoader1: false,
        assignDisabled1: false,
        createDisabled: false
        })
        
        this.fetchDispatch();
      })
      .catch(function(error) {});

  }

  UnAssignData(){
    const payload = {
      location: this.state.selectedLocation,
      type: "unassign",
      group_id: this.state.selectedGroup,
      order_id: unassign_arr

  };

API.post('/product/product_master/v1/group/unassign/', { param: payload })
      .then((response) => {
        alert(response.data.message);
        this.setState({
          variant1: response.data.data,
          loading_overlay: true,
        });
        
        this.fetchDispatch();
      })
      .catch(function(error) {});

  }


  checkAll1() {
    if (this.state.isChecked === false) {
      this.setState({
        isChecked: true,
        showSelectedBin: true,
      });

      //let newData = this.state.arr_data

      let newData = this.state.arr_data1.map((item) => ({
        ...item,
        isChecked: true,
      }));
       var arrayData = newData.filter(
      (item) => item.isChecked === true
    );

       var totalBill = 0;
     var totalWeight = 0;
     var totalValue = 0;
     var totalcld =0 ;
     var totalloose = 0;


     for(var i = 0 ; i < arrayData.length; i++){
      var totalBill1 = arrayData[i].bill_count;
      var totalBillValue = totalBill + totalBill1;
      totalBill = totalBillValue;

      var totalWeight1 = arrayData[i].weight;
      var totalWeightValue = totalWeight + totalWeight1;
      totalWeight = totalWeightValue;

      var totalcld1 = arrayData[i].inner;
      var totalCldValue = totalcld + totalcld1;
      totalcld = totalCldValue;

      var totalloose1 = arrayData[i].each;
      var totalLooseValue = totalloose + totalloose1;
      totalloose = totalLooseValue;
      
      var totalValue1 = arrayData[i].value;
      var totalValueTonnage = totalValue + totalValue1;
      totalValue = totalValueTonnage;
     }
  
      this.setState({
        tableRowsMap: this.assembleDispatchData(newData),
        arr_data1: newData,
         totalBillVal: totalBill,
      totalWeightVal: totalWeight.toFixed(2),
      total_cld: totalcld.toFixed(0),
      total_loose : totalloose.toFixed(0),
      totalTonnage: totalValue.toFixed(2),
        //SelectedBins: newBinData,
      });

      
    } else if (this.state.isChecked === true) {
      this.setState({
        isChecked: false,
        showSelectedBin: false,
      });

      let newData = this.state.arr_data1.map((item) => ({
        ...item,
        isChecked: false,
      }));

      this.setState({
        tableRowsMap: this.assembleDispatchData(newData),
        arr_data1: newData,
        totalBillVal: 0,
      totalWeightVal: 0,
      totalTonnage: 0,
      total_cld:0,
      total_loose:0
        //SelectedBins: newBinData,
      });

    }
  }


  checkAll() {
    if (this.state.isChecked1 === false) {
      this.setState({
        isChecked1: true,
        showSelectedBin: true,
      });

      let newData = this.state.arr_data.map((item) => ({
        ...item,
        isChecked: true,
      }));

      this.setState({
        tableRowsMap1: this.assembleDispatchData1(newData),
        arr_data: newData,
        //SelectedBins: newBinData,
      });

    } else if (this.state.isChecked1 === true) {
      this.setState({
        isChecked1: false,
        showSelectedBin: false,
      });

      let newData = this.state.arr_data.map((item) => ({
        ...item,
        isChecked: false,
      }));

      this.setState({
        tableRowsMap1: this.assembleDispatchData1(newData),
        arr_data: newData,
      });

    }
  }

  checkedSingle(index, ischecked,orderid) {
    
    var arr=[];
    this.setState({
      loading_overlay: true
    })
    let newData = this.state.arr_data;
    if (newData[index].isChecked === false) {
      newData[index].isChecked = true;
      data_type = "assign";
      assign_arr.push(orderid);
      
    } else if (newData[index].isChecked === true) {
      newData[index].isChecked = false;
      data_type = "unassign";
      unassign_arr.push(orderid);
      
    }
    this.setState({
      tableRowsMap1: this.assembleDispatchData1(newData),

    });

    
  }


  checkedSingle1(index, ischecked,orderid) {
    
    var arr=[];
    
    this.setState({
      loading_overlay: true
    })
    let newData = this.state.arr_data1;
    if (newData[index].isChecked === false) {
      newData[index].isChecked = true;
      data_type = "assign";
      assign_arr.push(orderid);
      
    } else if (newData[index].isChecked === true) {
      newData[index].isChecked = false;
      data_type = "unassign";
      unassign_arr.push(orderid);
      
    }

     var arrayData = newData.filter(
      (item) => item.isChecked === true
    );

     var totalBill = 0;
     var totalWeight = 0;
     var totalValue = 0;
     var totalcld = 0;
     var totalloose = 0;


     for(var i = 0 ; i < arrayData.length; i++){
      var totalBill1 = arrayData[i].bill_count;
      var totalBillValue = totalBill + totalBill1;
      totalBill = totalBillValue;

      var totalWeight1 = arrayData[i].weight;
      var totalWeightValue = totalWeight + totalWeight1;
      totalWeight = totalWeightValue;

      var totalValue1 = arrayData[i].value;
      var totalValueTonnage = totalValue + totalValue1;
      totalValue = totalValueTonnage;

      var totalcld1 = arrayData[i].inner;
      var totalCldValue = totalcld + totalcld1;
      totalcld = totalCldValue;

      var totalloose1 = arrayData[i].each;
      var totalLooseValue = totalloose + totalloose1;
      totalloose = totalLooseValue;
     }
    this.setState({
      tableRowsMap: this.assembleDispatchData(newData),
      arr_data1: newData,
      totalBillVal: totalBill,
      totalWeightVal: totalWeight.toFixed(2),
      totalTonnage: totalValue.toFixed(2),
      total_cld: totalcld.toFixed(0),
      total_loose : totalloose.toFixed(0),
      
      //binData: newData,
    });
    
  }


  changeEAN = (evt) => {
    this.setState({
      ean: evt.target.value,
    });
  };


  toggleOKNew() {
    this.setState((prevState) => ({ modalNew: !prevState.modalNew }));
    this.fetchDispatch();
    window.location.reload();
  }

  toggleNew() {
    this.setState((prevState) => ({ modalNew: !prevState.modalNew }));
  }

  toggleOK() {
    this.setState((prevState) => ({ modal: !prevState.modal }));
    this.fetchDispatch();
  }

  toggle() {
    this.setState((prevState) => ({ modal: !prevState.modal }));
  }
  Failedtoggle() {
    this.setState((prevState) => ({ Failedmodal: !prevState.Failedmodal }));
  }
  toggle1() {
    this.setState((prevState) => ({ modal1: !prevState.modal1 }));
  }

  toggleNPICancel() {
    this.setState((prevState) => ({
      modal1: !prevState.modal1,
      autoShelfLife: "",
      applyShelfLife: "",
      hsn_code: [],
      variant_data: [],
      pack_size1: [],
      shelf_life_data: [],
      applyVariant: "",
      applyTax: "",
      applyPackSize: "",
      autoMargin: "",
      autoSellingPrice: "",
      autoCostPrice: "",
      autoHsnCode: "",
      autoLongName: "",
      autoShortName: "",
      autoDesc: "",
      autoItemtype: "",
      autoVariant: "",
      autoPackSize: "",
      autoProductName: "",
      tax_percentage1: "",
      mc_code_value: "",
      brand: "",
      ean: "",
    }));
  }

  toggle2() {
    this.setState((prevState) => ({ modal2: !prevState.modal2 }));
    var arrayData = this.state.arr_data.filter(
      (item) => item.van_master == ""
    );

    var errMsg = arrayData.length + " " + "Bills are not assigned to any van"

    if(arrayData.length > 0){
      this.setState({
        reviewErr: errMsg
      })
    }else{
      this.setState({
        reviewErr: ""
      })

    }
    const payload = {
    //location: this.state.selectedLocation,
    group_id: this.state.selectedGroup,
    screen_type: "van_replanning_screen",
    from_date: From_Date_val,
    to_date: to_Date_val,
  };
  addAnalytics('Trip Planning', 'Trip Planning Review', payload);


API.post('/master_ptl/van/v1/orders/', { param: payload })
      .then((response) => {
        var res_data = []
        res_data = response.data; 
        
        localStorage.setItem("van_group", JSON.stringify(res_data));

        let reviewDataVal = response.data.data.map((item) => ({
          ...item,
          station: "",
          zone: ""
        }));
        this.setState({
          reviewData: reviewDataVal,
          // prod_arr : reviewDataVal,
          prod_arr : this.assembleProdData(reviewDataVal)
        });

      })
      .catch(function(error) {});
  }

  toggleFailed = () => {
    this.setState((prevState) => ({ modalFailed: !prevState.modalFailed }));
  }

  toggleFailedCancel = () => {
    this.setState({
      modalFailed: false,
      
    })
  }

  getVariant = () => {
    axios
      .post(
        "http://" + url + "/fms/stockcheck/v1/products/",

        {
          location: this.state.selectedLocation,
          api_type: "variant",
        },

        {
          headers: {
            "Content-Type": "application/json",
            //Authorization: Util.accessCookie("token"),
          },
        }
      )
      .then((response) => {
        this.setState({
          variant1: response.data.data,
        });
      })
      .catch(function(error) {});
  };

  radioChange(
    packSize,
    variant,
    shelf_life,
    product_id,
    product_name,
    mrp,
    tax_percentage,
    shelf_life_unit,
    pack_size_unit,
    long_name,
    short_name,
    hsn_code,
    desc,
    itemType,
    cost_price,
    selling_price,
    margin,
    brand,
    mc_code
  ) {
    this.setState({
      disabledVariant: true,
      disabledShelfLife: true,
      mc_code_value: mc_code,
      disabledProduct: true,
      disabledPackSize: true,
      autoLongName: long_name,
      autoShortName: short_name,
      brand: brand,
      autoHsnCode: hsn_code,
      autoDesc: desc,
      autoItemtype: itemType,
      autoCostPrice: cost_price,
      autoSellingPrice: selling_price,
      autoMargin: margin,
      autoPackSize: packSize,
      autoShelfLife: shelf_life,
      constantpacksize: packSize,
      constantvariant: variant,
      constantshelflife: shelf_life,
      constanttax: tax_percentage,
      tax_percentage1: tax_percentage,
      constantlongname: product_name,
      constantmrp1: mrp,
      shelf_unit: shelf_life_unit,
      pack_unit: pack_size_unit,
      autoVariant: variant,
      product_id: product_id,
      autoProductName: product_name,
      //mrp: mrp,
      pack_unit: pack_size_unit,
      shelf_unit: shelf_life_unit,
    });
  }

  getPacksize = () => {
    axios
      .post(
        "http://" + url + "/fms/stockcheck/v1/products/",

        {
          location: this.state.selectedLocation,
          api_type: "pack_size",
        },

        {
          headers: {
            "Content-Type": "application/json",
            //Authorization: Util.accessCookie("token"),
          },
        }
      )
      .then((response) => {
        this.setState({
          pack_size1: response.data.data,
        });
      })
      .catch(function(error) {});
  };

  changeHSN = (e) => {
    const value = e.target.value;
    this.setState({
      hsn_value: value,
      autoHsnCode: value,
    });
    axios
      .post(
        "http://" + url + "/fms/stockcheck/v1/products/",

        {
          location: this.state.selectedLocation,
          api_type: "tax_percentage",
          hsn_code: e.target.value,
          mc_code: this.state.mc_code_value,
        },

        {
          headers: {
            "Content-Type": "application/json",
            //Authorization: Util.accessCookie("token"),
          },
        }
      )
      .then((response) => {
        this.setState({
          tax_percentage: response.data.data,
          applyTax: response.data.data,
          tax_percentage1: response.data.data,
        });
      })
      .catch(function(error) {});
  };

  SuccessConfirmtoggle() {
    this.setState((prevState) => ({
      SuccessConfirmmodal: !prevState.SuccessConfirmmodal,
    }));
    this.setState({

        showCreatedId: false,
        showSelectGroup: false,
        showNewGroup: false,
        createDisabled: false
    })
  }


   SuccessConfirmtoggle1() {
    this.setState((prevState) => ({
      SuccessConfirmmodal1: !prevState.SuccessConfirmmodal1,
    }));
    this.setState({
       // SuccessConfirmmodal: false,
        showCreatedId: false,
        showSelectGroup: false,
        showNewGroup: false,
        createDisabled: false
    })
  }
  SuccessConfirmtoggle2() {
    this.setState((prevState) => ({
      SuccessConfirmmodal2: !prevState.SuccessConfirmmodal2,
    }));
    this.setState({
       // SuccessConfirmmodal: false,
        showCreatedId: false,
        showSelectGroup: false,
        showNewGroup: false,
        createDisabled: false
    })
  }

  componentWillMount() {
    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090";
    }else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    } else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41"+":8088";
    } else {
      url = window.location.hostname+port;
    }

     var today = new Date();
     From_Date_val = this.convertDate(today);
      to_Date_val = this.convertDate(today);
    
    sessionStorage.setItem('PUstore_id', '')
    sessionStorage.setItem('PUpolaris_id', '')
    sessionStorage.setItem('PUstatus_type', '')
    sessionStorage.setItem('PUtask_type_value', '')
    sessionStorage.setItem('PUtask_id', '')


    var cookieUsername = this.getCookie("token");
    var Location = this.getCookie("selectedLocation");
    var username = this.accessCookie("token");
    var invenOwner = this.getCookie("invOwner");
    this.setState(
      {
        userName: cookieUsername,
        invenOwner: invenOwner,
        fromdate:today,
        todate:today,
        selectedLocation: Location,
        store_id: sessionStorage.getItem('store_id') == "null" ? "" : sessionStorage.getItem('store_id') ,
        polaris_id: sessionStorage.getItem('polaris_id') == "null" ? "" : sessionStorage.getItem('polaris_id') ,
        task_id: sessionStorage.getItem('task_id') == "null" ? "" : sessionStorage.getItem('task_id') ,
        status_type: sessionStorage.getItem('status_type') == "null" || sessionStorage.getItem('status_type') == "" ? "1" : sessionStorage.getItem('status_type') ,
        task_type_value: sessionStorage.getItem('task_type_value') == "null" ? "" : sessionStorage.getItem('task_type_value')

      },
      () => {
        //this.fetchDispatch();
        this.getStoreList();
        this.getStation();
        this.getZone();
        // this.getOutletList();
        this.getVanList();
        this.getLocationList();
        // this.assignedOrdersList();
       
      }
    );

   
  }

  createCookie(cookieName, cookieValue, daysToExpire) {
    var date = new Date();
    date.setTime(date.getTime() + 1 * 24 * 60 * 60 * 1000);
    document.cookie =
      cookieName + "=" + cookieValue + "; expires=" + date.toGMTString();
  }

  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(";");
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  SuccessConfirmoktoggle() {
   var order_count = 0;
   var order_value = 0;
   var box_count = 0;
   var req_id = [];

   var area_code = [];
   for(var i = 0; i< this.state.arr_data.length; i++){
    if(this.state.arr_data[i].isChecked == true){
      order_count += this.state.arr_data[i].order_count;
      order_value += this.state.arr_data[i].order_value;
      box_count += this.state.arr_data[i].box_count;
      req_id = [...req_id, ...this.state.arr_data[i].req_ids];
      area_code.push(this.state.arr_data[i].area_code);


    }
   }

   var area_code_data = area_code.join(',')

    const payload = {
      location: this.state.selectedLocation,
      name: this.state.groupName,
      order_count: order_count,
      order_value: order_value,
      box_count: box_count,
      req_ids: req_id,
      area_code: area_code_data
  };

API.post('/sdr/vans/v1/create/', { param: payload })


      .then((response) => response.data)

      .then((data) => {

        this.setState({ selectedVan: data.data.van_id,showCreatedId: true, createDisabled: true, assignDisabled: false });
      })

      .then(async () => {
        
      });
   

    
  }

  getMCCode() {
    axios
      .post(
        "http://" + url + "/fms/stockcheck/v1/products/",

        {
          location: this.state.selectedLocation,
          api_type: "mc_code",
        },

        {
          headers: {
            "Content-Type": "application/json",
            //Authorization: Util.accessCookie("token"),
          },
        }
      )
      .then((response) => {

        this.setState({
          mc_code: true,
          mc_code_data: response.data.data,
        });
      })
      .catch(function(error) {});
  }

  getTaskTypeList() {
    axios
      .post(
        "http://" + url + "/fms/stockcheck/v1/products/",

        {
          location: this.state.selectedLocation,
          api_type: "task_types",
        },

        {
          headers: {
            "Content-Type": "application/json",
            //Authorization: Util.accessCookie("token"),
          },
        }
      )
      .then((response) => {
        this.setState({
          task_type: response.data.data,
        });
      })
      .catch(function(error) {});
  }

  getStoreList() {
     const payload = {
      screen_type: "van_replanning_screen",
  };

API.post('/product/product_master/v1/group/detail/', { param: payload })

      .then((response) => response.data)

      .then((data) => {

        this.setState({ store: data.data });
      })

      .then(async () => {
        
      });
  }
  getSubGroupStoreList(group_value) {
    const payload = {
     screen_type: "van_replanning_screen",
     group_id   : group_value
 };

API.post('/product/product_master/v1/subgroup/', { param: payload })

     .then((response) => response.data)

     .then((data) => {

       this.setState({ subGroupList: data.data });
     })

     .then(async () => {
       
     });
 }

  getVanList() {
    const payload = {
      location: this.state.selectedLocation,
      master_type: "customer_master",
      resp_type: "dropdown"
  };

API.post('/master_ptl/van/v1/', { param: payload })
      .then((response) => {

        this.setState({ van_list: response.data.data });
      })

      .then(async () => {
        
      });
  }

  getLocationList() {
    const payload = {
      location: this.state.selectedLocation,
      master_type: "delivery_center",
      resp_type: "dropdown",
      screen_type: "van_replanning_screen"
  };

API.post('/customer/view/v1/', { param: payload })
      .then((response) => {

        this.setState({ location: response.data.data[0] });
      })

      .then(async () => {
        
      });
  }


  getOutletList() {
    const payload = {
      location: this.state.selectedLocation,
      master_type: "outlet_master",
      resp_type: "dropdown"
  };

API.post('/sdr/orders/v1/', { param: payload })
      .then((response) => {

        this.setState({ areaCode: response.data.data });
      })

      .then(async () => {
        
      });
  }


  createGroup() {

    this.SuccessConfirmtoggle();
    
  }

  getTaskList() {
    axios
      .post(
        "http://" + url + "/fms/stockcheck/v1/products/",

        {
          location: this.state.selectedLocation,
          api_type: "task_ids",
        },

        {
          headers: {
            "Content-Type": "application/json",
            //Authorization: Util.accessCookie("token"),
          },
        }
      )
      .then((response) => {
        this.setState({
          task: response.data.data,
        });
      })
      .catch(function(error) {});
  }

  onQuantityChangeBrand = (e) => {
    const value = e.target.value;
    this.setState({
      new_brand: value,
    });
  };

  onQuantityChangeShelf = (e) => {
    const value = e.target.value;
    this.setState({
      autoShelfLife: value,
      shelf_life: value,
    });
  };

  changePackSize = (e) => {
    const value = e.target.value;

    if (
      e.target.value !== "others" &&
      e.target.value != "" &&
      e.target.value != "undefined" &&
      e.target.value != "null"
    ) {
      const clickedOption = this.state.pack_size1.find(
        (item) => item.id == e.target.value
      );

      this.setState({
        applyPackSize: clickedOption.name,
        pack_unit: clickedOption.unit,
        autoPackSize: clickedOption.name,
        showPackSize: false,
      });
    } else {
      if (e.target.value == "") {
        this.setState({
          showPackSize: false,
        });
      } else {
        this.setState({
          showPackSize: true,
        });
      }

      this.setState({
        //showPackSize: true,
        applyPackSize: "",
        pack_unit: "",
        autoPackSize: "",
      });

      axios
        .post(
          "http://" + url + "/fms/stockcheck/v1/products/",
          {
            api_type: "pack_size_unit",
          },
          {
            headers: {
              "Content-Type": "application/json",
              //Authorization: Util.accessCookie("token"),
            },
          }
        )
        .then((response) => response.data)
        .then((data) => {
          this.setState({
            pack_size_uom: data.data,
          });
        })
        .catch(function(error) {});
    }
  };

  changeShelfLife = (e) => {
    const value = e.target.value;

    if (
      e.target.value !== "others" &&
      e.target.value != "" &&
      e.target.value != "undefined" &&
      e.target.value != "null"
    ) {
      const clickedOption = this.state.shelf_life_data.find(
        (item) => item.id == value
      );

      this.setState({
        applyShelfLife: clickedOption.name,
        shelf_unit: clickedOption.unit,
        autoShelfLife: clickedOption.name,
        showShelfLife: false,
      });
    } else {
      if (e.target.value == "") {
        this.setState({
          showShelfLife: false,
        });
      } else {
        this.setState({
          showShelfLife: true,
        });
      }
      this.setState({
        /*showShelfLife: true,*/
        applyShelfLife: "",
        shelf_unit: "",
        autoShelfLife: "",
      });

      axios
        .post(
          "http://" + url + "/fms/stockcheck/v1/products/",
          {
            api_type: "shelf_life_unit",
          },
          {
            headers: {
              "Content-Type": "application/json",
              //Authorization: Util.accessCookie("token"),
            },
          }
        )
        .then((response) => response.data)
        .then((data) => {
          this.setState({
            shelf_life_uom: data.data,
          });
        })
        .catch(function(error) {});
    }
  };

  changeVariant = (e) => {
    const value = e.target.value;
    this.setState({
      applyVariant: value,
    });

    if (e.target.value == "others") {
      this.setState({
        showVariant: true,
        applyVariant: "",
        autoVariant: "",
      });
    } else {
      this.setState({
        showVariant: false,
        autoVariant: value,
      });
    }
  };

  changeManualPack = (e) => {
    const value = e.target.value;
    this.setState({
      applyPackSize: value,
      autoPackSize: value,
    });
  };

  changeManualVariant = (e) => {
    const value = e.target.value;
    this.setState({
      applyVariant: value,
      autoVariant: value,
    });
  };

  changeManualShelf = (e) => {
    const value = e.target.value;
    this.setState({
      applyShelfLife: value,
      autoShelfLife: value,
    });
  };

  changeMrp1 = (e) => {
    const value = e.target.value;
    this.setState({
      applyMrp: value,
      mrp: value,
    });
  };

  changePackUOM = (e) => {
    const value = e.target.value;
    this.setState({
      applyPackUOM: value,
      pack_unit: value,
    });
  };

  /*changePackUOM=(e) =>{
     const value = e.target.value
    this.setState({
      applyPackUOM: value
    })


  }*/

  changeShlefUOM = (e) => {
    const value = e.target.value;
    this.setState({
      applyShelfUOM: value,
      shelf_unit: value,
    });
  };

  onPLGroupChange = (e) => {
    const value = e.target.value;
    this.setState({
      pl_group: value,
      
    });
  };

  onAreaCodeChange = (e) => {
    const value = e.target.value;
    this.setState({
      area_code: value,
      
    });
  };

  onBillRangeChange = (e) => {
    const value = e.target.value;
    this.setState({
      bill_range: value,
      
    });
  };

   onBillValueeChange = (e) => {
    const value = e.target.value;
    this.setState({
      bill_value: value,
      
    });
  };

  onWeightChange = (e) => {
    const value = e.target.value;
    this.setState({
      weight: value,
      
    });
  };

  onVolumeChange = (e) => {
    const value = e.target.value;
    this.setState({
      volume: value,
      
    });
  };

  onVanFilterChange = (e) => {
    const value = e.target.value;
    this.setState({
      selectedVanFilter: value,
      
    });
  };



  changeProductName = (e) => {
    const value = e.target.value;
    this.setState({
      autoProductName: value,
      color_product: false,
    });
  };

  onQuantityChangePackSize = (e) => {
    const value = e.target.value;
    this.setState({
      autoPackSize: value,
      packSize: value,
      color_packSize: false,
    });
  };

  changeMrp = (e) => {
    const value = e.target.value;
    this.setState({
      mrp: value,
      color_mrp: false,
    });
  };

  changeMrp = (e) => {
    const value = e.target.value;
    this.setState({
      mrp: value,
      color_mrp: false,
    });
  };

  onQuantityChangeTax = (e) => {
    const value = e.target.value;
    this.setState({
      tax_percentage1: value,
      color_tax: false,
    });
  };

  onQuantityChangeVariant = (e) => {
    const value = e.target.value;
    this.setState({
      autoVariant: value,
      variant: value,
      color_variant: false,
    });
  };

  OpenAssign(){
  this.SuccessConfirmtoggle();
  }


  OpenAssign1(){
  this.SuccessConfirmtoggle1();
  }
  OpenAssign2(){
    this.SuccessConfirmtoggle2();
    }
  

  handleChange1 = (e) => {
    this.setState({
      selectedGroup: e.target.value,
      assignDisabled: false
    });
    this.getSubGroupStoreList(e.target.value);
  };
  handleSubgroupChange = (e) => {
    this.setState({
      selectedSubGroup: e.target.value,
      assignDisabled: false,
    });
    
  };


  handleChangeVanVal(e, callback){
        const value = (e.target.value) ? e.target.value.replace(/[^0-9a-zA-Z]+/ig, "") : '';
          this.setState({
            selectedVan: value,
            assignDisabled: false
          })

          if (e.target.value !== value) {
              e.target.value = value;


          }

          
  };

  handleChangeVan1Val(e, callback){
        const value = (e.target.value) ? e.target.value.replace(/[^0-9a-zA-Z]+/ig, "") : '';
          this.setState({
      
            selectedVan1: value,
            assignDisabled: false
          })

          if (e.target.value !== value) {
              e.target.value = value;


          }

          
  };

  validateInput = (e) => {
    alert("rtyt")
    var k = e.keyCode || e.which;
    var ok = k >= 65 && k <= 90 || // A-Z
      k >= 96 && k <= 105 || // a-z
      k >= 35 && k <= 40 || // arrows
      k == 9 || //tab
      k == 46 || //del
      k == 8 || // backspaces
      (!e.shiftKey && k >= 48 && k <= 57); // only 0-9 (ignore SHIFT options)

    if(!ok || (e.ctrlKey && e.altKey)){
      e.preventDefault();
    }
  }

  ChangeLocation = (e) => {
    this.setState({
      selectedLocation1: e.target.value,
    });
  };

  ChangeOutlet = (e) => {
    this.setState({
      selectedOutlet: e.target.value,
    });
  };

  ChangeDistributor = (e) => {
      this.setState({
        selectedDistributor: e.target.value,
      });
  };

  ChangeOrder = (e) => {
      this.setState({
        selectedOrder: e.target.value,
      });
  };

  radioChangeGroup(data){
    if(data == "exsisting"){
      this.setState({
        showSelectGroup: true,
        showNewGroup: false,
        assignDisabled: true
      })
    }else if(data == "new"){
      this.setState({
        showSelectGroup: false,
        showNewGroup: true,
        assignDisabled: true
      })
    }
  }



  handleChange2 = (e) => {
    this.setState({
      task_id: e.target.value,
    });
  };
  handleChange3 = (e) => {
    this.setState({
      polaris_id: e.target.value,
    });
  };
  handleChange4 = (e) => {
    this.setState({
      task_type_value: e.target.value,
    });
  };

  handleChange5 = (e) => {
    this.setState({
      status_type: e.target.value,
    });
  };

  assembleDispatchData = (dispatchData) => {
    let DispatchData = dispatchData.map((post, index) => {
     

      return {
        icon: (post.van_master == "") || (post.bill_count !== post.planned_bills) ?<span> <span style={{color: 'red'}} href="#" id="TooltipExample" class="fa fa-info-circle"></span><Tooltip placement="right" isOpen={this.state.tooltipOpen} target="TooltipExample" toggle={this.toggleTooltip}>
          Van Assigned to this bill
        </Tooltip></span> : <span style={{width:40}}></span>,
        
        action: <input style={{textAlign: 'center'}} type="checkbox" value={post.isChecked} checked={post.isChecked} onChange={() => this.checkedSingle1(index,post.isChecked, post.id)}/>,
        
        
        area_code: <span style={{color:'#153699', cursor: 'pointer', fontWeight: 'bold'}} onClick={() => this.getBillList(index,post.area_code,post.pl_group)}>{post.area_code}</span>,
        pl_group: post.pl_group,
        bill_count: post.bill_count,
        value: post.value,
        weight: post.weight,
        planned_bills:post.planned_bills,
        van_master: post.van_master,
        merlin_vans : post.merlin_vans,
        inner:post.inner,
        each:post.each,
        
      };
    });

    this.setState({
      loading_overlay: false,
      loading: false,
    });

    return DispatchData;
  };
  assembleProdData = (dispatchData) => {
    let DispatchData = dispatchData.map((item, index) => {
      return {
        van_id : item.van_id,
        order_id : item.orders,
        van_name :item.van_name,
        total_bills :item.total_bills,
        total_values : item.total_values,
        total_weight : item.total_weight,
        location : <a href="/view_map" onClick={()=> localStorage.setItem("selected_van",item.van_name)}>View Map</a>
      };
    });

    this.setState({
      loading_overlay: false,
      loading: false,
      prod_arr : DispatchData

    });

    return DispatchData;
  };

  assembleDispatchData1 = (dispatchData) => {
    let DispatchData1 = dispatchData.map((post, index) => {
     
       return {
        icon: post.van_master == "" ?<span> <span style={{color: 'red'}} href="#" id="TooltipExample" class="fa fa-info-circle"></span><Tooltip placement="right" isOpen={this.state.tooltipOpen} target="TooltipExample" toggle={this.toggleTooltip}>
          Van Assigned to this bill
        </Tooltip></span> : "",
        
        action: <input type="checkbox" value={post.isChecked} checked={post.isChecked} onChange={() => this.checkedSingle(index,post.isChecked, post.id)}/>,
        
        bill_number: <span> {post.bill_number}</span>,
        distributor_code: post.distributor_code,
        retailer_code:post.retailer_code,
        party_name: post.party_name,
        area: post.area,
        value: post.value,
        weight: post.weight,
        van_master: post.van_master,
        inner:post.inner,
        each:post.each,
        
      };

     
    });
  
    this.setState({
      loading_overlay: false,
      loading: false,
    });

    return DispatchData1;
  };


  onCheck(
    taskid,
    mcCode,
    brand,
    longName,
    packsize,
    variant,
    mrp,
    ean,
    shelf_life,
    image1,
    image2,
    image3,
    image4,
    image5,
    tax_percentage,
    product_id,
    request_id,
    updated_fields,
    productName,
    variant_image,
    pack_size_image,
    task_detail_id
  ) {
    data_img = [];
    this.setState({
      apply: true,
      showTable: false,
      showFilter: false,
      updated_fields: updated_fields,
      color_variant: updated_fields.indexOf("variant") > -1 ? true : false,
      color_packSize: updated_fields.indexOf("pack_size") > -1 ? true : false,
      color_shelf: updated_fields.indexOf("shelf_life") > -1 ? true : false,
      color_product:
        updated_fields.indexOf("polaris_item_long_name") > -1 ? true : false,
      color_mrp: updated_fields.indexOf("mrp") > -1 ? true : false,
      color_tax: updated_fields.indexOf("tax_percentage") > -1 ? true : false,
      color_brand: updated_fields.indexOf("brand") > -1 ? true : false,
      color_mc_code: updated_fields.indexOf("mc_code") > -1 ? true : false,
      color_ean: updated_fields.indexOf("ean") > -1 ? true : false,
      request_id: request_id,
      taskId: taskid,
      mcCode: mcCode,
      brand: brand,
      brand_value: brand,
      autoProductName: longName,
      autoPackSize: packsize,
      autoShelfLife: shelf_life,
      autoVariant: variant,
      packSize: packsize,
      product_name_val: productName,
      variant: variant,
      constantmrp: mrp,
      constantmrp1: mrp,
      //applyMrp: mrp,
      constantlongname: longName,
      constanttax: tax_percentage,
      constantpacksize: packsize,
      constantvariant: variant,
      constantshelflife: shelf_life,
      mrp: mrp,
      tax_percentage1: tax_percentage,
      ean: ean,
      shelf_life: shelf_life,
      image1: image1,
      image2: image2,
      image3: image3,
      image4: image4,
      image5: image5,
    });

    /*data_img = [*/

    if (image1) {
      var orderData1 = {};
      orderData1["image"] = image1;
      orderData1["text"] = "Brand";

      data_img.push(orderData1);
    }

    if (image3) {
      var orderData2 = {};
      orderData2["image"] = image3;
      orderData2["text"] = "MRP";

      data_img.push(orderData2);
    }

    if (image4) {
      var orderData3 = {};
      orderData3["image"] = image4;
      orderData3["text"] = "Shelf Life";

      data_img.push(orderData3);
    }

    if (image5) {
      var orderData4 = {};
      orderData4["image"] = image5;
      orderData4["text"] = "Product";

      data_img.push(orderData4);
    }

    if (variant_image) {
      var orderData4 = {};
      orderData4["image"] = variant_image;
      orderData4["text"] = "Variant";

      data_img.push(orderData4);
    }

    if (pack_size_image) {
      var orderData5 = {};
      orderData5["image"] = pack_size_image;
      orderData5["text"] = "Pack Size";

      data_img.push(orderData5);
    }

    localStorage.setItem("imgData", JSON.stringify(data_img));
    localStorage.setItem("longName", longName);
    localStorage.setItem("mrp", mrp);
    localStorage.setItem("ean", ean);
    localStorage.setItem("request_id", request_id);
    localStorage.setItem("task_id", taskid);
    localStorage.setItem("brand", brand);
    localStorage.setItem("task_detail_id", task_detail_id);
    localStorage.setItem("tax_percentage", tax_percentage);
    localStorage.setItem(
      "color_variant",
      updated_fields.indexOf("variant") > -1 ? true : false
    );
    localStorage.setItem(
      "color_packSize",
      updated_fields.indexOf("pack_size") > -1 ? true : false
    );
    localStorage.setItem(
      "color_shelf",
      updated_fields.indexOf("shelf_life") > -1 ? true : false
    );
    localStorage.setItem(
      "color_brand",
      updated_fields.indexOf("brand") > -1 ? true : false
    );
    localStorage.setItem(
      "color_mrp",
      updated_fields.indexOf("mrp") > -1 ? true : false
    );
    localStorage.setItem(
      "color_product",
      updated_fields.indexOf("polaris_item_long_name") > -1 ? true : false
    );


    axios
      .post(
        "http://" + url + "/fms/stockcheck/v1/products/",
        {
          api_type: "shelf_life_unit",
        },
        {
          headers: {
            "Content-Type": "application/json",
            //Authorization: Util.accessCookie("token"),
          },
        }
      )
      .then((response) => response.data)
      .then((data) => {
        this.setState({
          shelf_life_uom: data.data,
        });
      })
      .catch(function(error) {});

    axios
      .post(
        "http://" + url + "/fms/stockcheck/v1/products/",
        {
          api_type: "pack_size_unit",
        },
        {
          headers: {
            "Content-Type": "application/json",
            //Authorization: Util.accessCookie("token"),
          },
        }
      )
      .then((response) => response.data)
      .then((data) => {
        this.setState({
          pack_size_uom: data.data,
        });
      })
      .catch(function(error) {});

    this.viewImage();
  }

  onConfirm() {
    this.setState({
      ShowConfirmLoader: true,
    });
    if (
      this.state.autoLongName == "" ||
      this.state.autoShortName == "" ||
      this.state.autoHsnCode == "" ||
      this.state.autoDesc == "" ||
      this.state.autoItemtype == "" ||
      this.state.autoSellingPrice == "" ||
      this.state.autoCostPrice == "" ||
      this.state.autoMargin == "" ||
      this.state.ean == "" ||
      this.state.mrp == "" ||
      this.state.autoPackSize == "" ||
      this.state.brand == "" ||
      this.state.mrp == "" ||
      this.state.autoShelfLife == "" ||
      this.state.autoVariant == "" ||
      this.state.tax_percentage1 == ""
    ) {
      this.setState({
        showConfirmError: true,
        ShowConfirmLoader: false,
      });
      return false;
    } else {
      this.setState({
        showConfirmError: false,
      });
    }

    axios
      .post(
        "http://" + url + "/fms/stockcheck/v1/products/",
        {
          api_type: "status_update",
          task_id: this.state.request_id,
          polaris_item_long_name: this.state.autoLongName,
          polaris_item_short_name: this.state.autoShortName,
          hsn_code: this.state.autoHsnCode,
          mc_desc: this.state.autoDesc,
          item_type: this.state.autoItemtype,
          cost_price: this.state.autoCostPrice,
          sell_price: this.state.autoSellingPrice,
          margin: this.state.autoMargin,
          ean: this.state.ean,
          mrp: this.state.mrp,
          brand: this.state.brand,
          pack_size: this.state.autoPackSize,
          tax_percentage: this.state.tax_percentage1,
          shelf_life: this.state.autoShelfLife,
          variant: this.state.autoVariant,
          product_item_name: this.state.autoProductName,
          product_id: this.state.product_id,
          pack_size_unit: this.state.pack_unit,
          shelf_life_unit: this.state.shelf_unit,

          //"status": 3,
          remarks: "",
        },
        {
          headers: {
            "Content-Type": "application/json",
            //Authorization: Util.accessCookie("token"),
          },
        }
      )
      .then((response) => response.data)
      .then((data) => {
        this.setState({
          success_message: data.message,
          ShowConfirmLoader: false,
        });
        this.toggle1();
        this.toggle();

        this.fetchDispatch();
      })
      .catch(function(error) {});

    this.setState((prevState) => ({
      autoShelfLife: "",
      applyShelfLife: "",
      hsn_code: [],
      variant_data: [],
      pack_size1: [],
      shelf_life_data: [],
      applyVariant: "",
      applyTax: "",
      applyPackSize: "",
      autoMargin: "",
      autoSellingPrice: "",
      autoCostPrice: "",
      autoHsnCode: "",
      autoLongName: "",
      autoShortName: "",
      autoDesc: "",
      autoItemtype: "",
      autoVariant: "",
      autoPackSize: "",
      autoProductName: "",
      tax_percentage1: "",
      mc_code_value: "",
      brand: "",
      ean: "",
    }));
  }


onConfirmProduct() {
    this.setState({
      disable_submit_button: true,
      ShowEditLoader: true
    
    })

var arrayData = this.state.arr_data1

 var arr = [];
 var pl_arr = [];
 var order_id = [];
 var van_arr = [];
  
for (var i = 0; i < arrayData.length; i++) {
  
  for(var j = 0; j< arrayData[i].orders.length ; j++){
    
    order_id.push(arrayData[i].orders[j]);
  }
  arr.push({"area_code":arrayData[i].area_code,"van_id":arrayData[i].van_master,"pl_group":arrayData[i].pl_group,"order_id":arrayData[i].orders})


}

var req_id = [];

const payload = {
 
      order_details : assign_arr,
      group_id: this.state.selectedGroup,
      screen_type: "van_replanning_screen"
  
};
addAnalytics('Trip Planning', 'Trip Planning Confirm Data', payload);


API.post('/master_ptl/van/v1/reassign/', { param: payload })
  .then((response) => {
  
    this.setState({

      variant1: response.data.data,
      loading_overlay: true,
      success_message: response.data.message,
      totalBillVal: 0,
      totalTonnage: 0,
      totalWeightVal: 0,
      assignLoader1: false,

    });
    if(response.data.success == true){
      this.toggle();
      this.setState({ShowEditLoader: false,
      disable_submit_button: false
      });

    }else{
    this.Failedtoggle();
    }
    this.setState({
    SuccessConfirmmodal2: false,
    showCreatedId: false,
    showSelectGroup: false,
    showNewGroup: false,
    assignLoader1: false,
    assignDisabled1: false,
    createDisabled: false,
    modal2:false,
    })
    
    this.fetchDispatch();
  })
  .catch(function(error) {});

}

  
  onApply(taskid) {
    this.setState({
      apply: true,
      tax_percentage1: this.state.applyTax,
      autoVariant: this.state.applyVariant,
      autoShelfLife: this.state.applyShelfLife,
      autoPackSize: this.state.applyPackSize,
      // ShowpopupLoader: true,
      showTable: false,
      isDisabledSearch: true,
      /*isDisabledApply: true*/
    });

    axios
      .post(
        "http://" + url + "/fms/stockcheck/v1/products/",
        {
          api_type: "all_products",
          mc_code: this.state.mc_code_value,
          //"brand": this.state.brand_value,
          hsn_code: this.state.hsn_value,
          mrp: this.state.applyMrp,
          pack_size: this.state.applyPackSize,
          shelf_life: this.state.applyShelfLife,
          variant: this.state.applyVariant,
          tax_percentage: this.state.applyTax,
          pack_size_unit: this.state.pack_unit,
          shelf_life_unit: this.state.shelf_unit,
          article_id: this.state.article_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            //Authorization: Util.accessCookie("token"),
          },
        }
      )
      .then((response) => response.data)
      .then((data) => {
        if (data.data.length == 0) {
          this.setState({
            showTable: false,
            showFilter: false,
          });
        } else {
          this.setState({
            showTable: true,
            showFilter: true,
          });
        }
        this.setState({
          row_data: data.data,
          ShowpopupLoader: false,
          isDisabledSearch: false,
          loader1: false,
          //isDisabledApply: false
        });
      })
      .catch(function(error) {});
  }

  onApply2(taskid) {
    this.setState({
      row_data: [],
      apply: true,
      tax_percentage1: this.state.applyTax,
      autoVariant: this.state.applyVariant,
      autoShelfLife: this.state.applyShelfLife,
      autoPackSize: this.state.applyPackSize,
      ShowpopupLoader: true,
      showTable: true,
      isDisabledSearch: true,
      /*isDisabledApply: true*/
    });

    axios
      .post(
        "http://" + url + "/fms/stockcheck/v1/products/",
        {
          api_type: "all_products",
          mc_code: this.state.mc_code_value,
          //"brand": this.state.brand_value,
          hsn_code: this.state.hsn_value,
          mrp: this.state.applyMrp,
          pack_size: this.state.applyPackSize,
          shelf_life: this.state.applyShelfLife,
          variant: this.state.applyVariant,
          tax_percentage: this.state.applyTax,
          pack_size_unit: this.state.pack_unit,
          shelf_life_unit: this.state.shelf_unit,
          article_id: this.state.article_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            //Authorization: Util.accessCookie("token"),
          },
        }
      )
      .then((response) => response.data)
      .then((data) => {
        if (data.data.length == 0) {
          this.setState({
            showTable: false,
          });
        } else {
          this.setState({
            showTable: true,
          });
        }
        this.setState({
          row_data: data.data,
          ShowpopupLoader: false,
          isDisabledSearch: false,
          loader1: false,
          //isDisabledApply: false
        });
      })
      .catch(function(error) {});
  }

  SearchData(){
    this.setState({
    loading_overlay: true
    })
    var newArrData = [];
   
     newArrData = this.state.arr_data.filter(
      (item) => item.party_code == this.state.selectedOutlet || item.distributor_code == this.state.selectedDistributor || item.delivery_center == this.state.selectedLocation || item.outlet_order_no == this.state.selectedOrder
    );
   

    this.setState({
    arr_data: newArrData,
    tableRowsMap: this.assembleDispatchData(newArrData),
    })
  }

  formatDate = (date) => {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [day, month, year].join('-');
}

 
  convertDate = (inputFormat) => {
  function pad(s) { return (s < 10) ? '0' + s : s; }
  var d = new Date(inputFormat)
  return [d.getFullYear(), pad(d.getMonth()+1), pad(d.getDate())].join('-')
}

  FromDateChange = date  => {
      this.setState({
        fromdate :  date
      }) 
      if(date != null){
      From_Date_val = this.convertDate(date);
      } else{
        From_Date_val= ""
      }
      
      
  }

  ToDateChange = date => {
      const d = new Date(date);
      this.setState({
        todate :  date
      }) 
      
       if(date != null){
      to_Date_val = this.convertDate(date); 
      } else{
        to_Date_val= ""
      }
  }

  getZone =()=> {

     const payload = {
      "station_type":"PTL",
  };

API.post('/product/product_master/v1/station/dropdown/', { param: payload })
      .then((response) => response.data)
      .then((data) => {
      
       this.setState({
       zoneData: data.data
       })
      })
      .catch(function(error) {});
      
      
  }


   getStation =()=> {

     const payload = {
      location: this.state.selectedLocation,
  };

API.post('/product/product_master/v1/station/type/dropdown/', { param: payload })
      .then((response) => response.data)
      .then((data) => {
       
       this.setState({
        stationData: data.data
       })
      })
      .catch(function(error) {});
      
      
  }


  fetchDispatch = (order_no) => {
  
    this.setState({
      loading: true,
    });


    const payload = {
   
          group_id: this.state.selectedGroup,
          pl_group: this.state.pl_group,
          subgroup_id : this.state.selectedSubGroup,
          area_code: this.state.area_code,
          bill_range: this.state.bill_range,
          bill_value: this.state.bill_value,
          van_name: this.state.selectedVanFilter,
          weight: this.state.weight,
          volume: this.state.volume,
          location: this.state.selectedLocation,
          from_data: From_Date_val,
          to_date: to_Date_val,
          screen_type: "van_replanning_screen"
  };
   addAnalytics('Trip Planning', 'Trip Planning Search Filter', payload);

API.post('/master_ptl/view/v1/area_group/', { param: payload })
      .then((response) => response.data)
      .then((data) => {

        this.setState({
          showFetchDispatchData: true,
        });

        var arr = data.data;
        
        

        let UnAssignData = arr.map((item) => ({
          ...item,
          isChecked: false,
        }));

        this.setState({
          orderData: data.data,
          total_value: data.data.total_value,
          total_quantity: data.data.total_qty,
          arr_data1: UnAssignData,
          tableRowsMap: this.assembleDispatchData(UnAssignData),
          showFetchDispatchData: true,
          dispatch_status: false,
          
        });
      })
      .catch(function(error) {});
  };


   getBillList(index, area_code, pl_group){
    var arr_data = [];
    var total_val = 0;
    var total_qty = 0;
    this.setState({
      //loading_overlay: true,
      loading: true,
    });

    var batch = localStorage.getItem('batch_id');

    const payload = {
     //location: this.state.selectedLocation1,
          //"data_type": "unassigned",
          group_id: this.state.selectedGroup,
          pl_group: pl_group,
          area_code: area_code,
          bill_range: this.state.bill_range,
          bill_value: this.state.bill_value,
          weight: this.state.weight,
          volume: this.state.volume,
          //outlet: this.state.selectedOutlet,
          //location: this.state.selectedLocation,
          van_name : this.state.selectedVanFilter,
          from_data: From_Date_val,
          to_date: to_Date_val
  };

API.post('/master_ptl/view/v1/', { param: payload })
      .then((response) => response.data)
      .then((data) => {

        this.setState({
          showFetchDispatchData1: true,
        });

        var arr = data.data;

        const sortNullishValues = (arr = []) => {
         const assignValue = val => {
            if(val == ""){
               
                return val;
            }
            else{
              return Infinity;
            };
         };
         const sorter = (a, b)=> {
            return assignValue(a.van_master) - assignValue(b.van_master);
         };
         arr.sort(sorter);
      }
      sortNullishValues(arr); 

        let UnAssignData = arr.map((item) => ({
          ...item,
          isChecked: false,
        }));
    

        this.setState({
          orderData: data.data,
          total_value: data.data.total_value,
          total_quantity: data.data.total_qty,
          arr_data: UnAssignData,
          tableRowsMap1: this.assembleDispatchData1(UnAssignData),
          showFetchDispatchData1: true,
          dispatch_status: false,
        });
        this.toggle1();
      })
      .catch(function(error) {});
  };



  render() {
    const { handleSubmit, reset, t } = this.props;
    const { showPassword } = this.state;
    const { modal, modal1, modal2, modalNew } = this.state;
    const { modalFailed, modalReason } = this.state;
    const { SuccessConfirmmodal, Failedmodal,SuccessConfirmmodal1 ,SuccessConfirmmodal2} = this.state;
    const { EditModal,inventData } = this.state;

    const dispatchData = {
      columns: [
        
        {
          label: <input type='checkbox' checked={this.state.isChecked} onChange={() => this.checkAll1()} />,

          field: "action",
          width: 50,
        },
        
        {
          label: "Area group",

          field: "area_code",
          width: 100,
        },
        {
          label: "PL Group",

          field: "pl_group",
          width: 100,
        },
        {
          label:"Assigned Bill",
          field:"planned_bills",
          width:90,
        },
        {
          label: "Bill Count",

          field: "bill_count",
          width: 80,
        },

        {
          label: "Value",

          field: "value",
          width: 90,
        },

        {
          label: "Inner",

          field: "inner",
          width: 80,
        },

        {
          label: "Each",

          field: "each",
          width: 80,
        },


        {
          label: "Weight",

          field: "weight",
          width: 90,
        },
        {
          label: "Van",

          field: "van_master",
          width: 80,
        },
        {
          label: "Merlin Van Id",

          field: "merlin_vans",
          width: 80,
        }
        

      ],

      rows: this.state.tableRowsMap,
    };




    const dispatchData1 = {
      columns: [
        {
          label: <input type='checkbox' checked={this.state.isChecked1} onChange={() => this.checkAll()} />,

          field: "action",
          width: 35,
        },
        
        {
          label: "Bill No.",

          field: "bill_number",
          width: 100,
        },
        {
          label: "Distributor Code",

          field: "distributor_code",
          width: 140,
        },
        {
          label: "Retailer Code",

          field: "retailer_code",
          width: 140,
        },

        {
          label: "Party Name",

          field: "party_name",
          width: 185,
        },


        {
          label: "Area",

          field: "area",
          width: 120,
        },

        {
          label: "Value",

          field: "value",
          width: 90,
        },
        {
          label: "Inner",

          field: "inner",
          width: 90, 
        },
        {
          label: "Each",

          field: "each",
          width: 90,
        },


        {
          label: "Weight",

          field: "weight",
          width: 100,
        },
        {
          label: "Van",

          field: "van_master",
          width: 170,
        }

        

      ],

      rows: this.state.tableRowsMap1,
    };
    
    const GROUPED_COLUMNS = [
      {
          Header: 'Van Name',
          accessor: 'van_name'
      },

      {
          Header: 'Total Bill',
          accessor: 'total_bills'
      },
      {
          Header: 'Total Values',
          accessor: 'total_values'
      },
      {
          Header: 'Total Weight',
          accessor: 'total_weight'
      },
      {
        Header: 'Location',
        accessor: 'location',
    },


  ]



  const GlobalFilter = ({ filter, setFilter }) => {
      const [value, setValue] = useState(filter)
      const onChange = useAsyncDebounce(value => {
          setFilter(value || undefined)
      }, 1000)
      return (
          <span >
              {' '}
              <input className="input_border"
                  value={value || ''}
                  placeholder="Search"
                  onChange={e => {
                      setValue(e.target.value);
                      onChange(e.target.value);


                  }}
              />
          </span>
      )
  }
  const PaginationTable = () => {
      const columns = useMemo(() => GROUPED_COLUMNS, [])
      const data = useMemo(() => this.state.prod_arr, [])
      const {
          getTableProps,
          getTableBodyProps,
          headerGroups,
          rows,
          page,
          nextPage,
          previousPage,
          canPreviousPage,
          canNextPage,
          pageOptions,
          state,
          setGlobalFilter,
          gotoPage,
          pageCount,
          setPageSize,
          selectedFlatRows,
          prepareRow
      } = useTable(
          {
              columns,
              data,
              initialState: { pageIndex: 0, pageSize: this.state.prod_arr.length },
          },

          useGlobalFilter,
          useSortBy,
          usePagination,
          useRowSelect,
          hooks => {
              hooks.visibleColumns.push(columns => [
                  {
                      id: 'selection',
                      Header: ({ getToggleAllRowsSelectedProps }) => (
                          <Checkbox {...getToggleAllRowsSelectedProps()} />
                      ),
                      Cell: ({ row }) => <Checkbox {...row.getToggleRowSelectedProps()} />
                  },
                  ...columns
              ])
          }

      )
      var new_arr_data = selectedFlatRows.map(row => row.original);
      var s_bill = selectedFlatRows.length;
      assign_arr = new_arr_data;



      const { pageIndex, pageSize, globalFilter } = state
      const firstPageRows = rows.slice(0, 10)

      return (
          <>
              {/* <p style={{ fontWeight: "bold", marginBottom: 0 }}>Stock Transfer Details</p>
              <hr style={{ marginTop: 0 }} />
              <div style={{ textAlign: "right", paddingBottom: "5px", marginTop: "-10px" }}><GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} /></div> */}
              <table id="customers" style={{ width: "100%" ,height :"100%"}}{...getTableProps()}>
                  <thead>
                      {headerGroups.map(headerGroup => (
                          <tr {...headerGroup.getHeaderGroupProps()}>
                              {headerGroup.headers.map(column => (
                                  <th style={{ textAlign: "center" }} {...column.getHeaderProps(column.getSortByToggleProps())}>{column.render('Header')}
                                      <span>
                                          {column.isSorted
                                              ? column.isSortedDesc
                                                  ? ' 🔽'
                                                  : ' 🔼'
                                              : ''}
                                      </span>
                                  </th>
                              ))}
                          </tr>
                      ))}
                  </thead>
                  <tbody {...getTableBodyProps()}>
                      {page.map(row => {
                          prepareRow(row)
                          return (
                              <tr {...row.getRowProps()}>
                                  {row.cells.map(cell => {
                                      return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                                      
                                  })}
                              </tr>
                          )
                      })}
                  </tbody>

              </table>

          </>

      )
  }


  const selectedOptionsStyles = {
      color: "#3c763d",
      backgroundColor: "#dff0d8",
  };
  const optionsListStyles = {
      backgroundColor: "#dff0d8",
      color: "#3c763d",
  };
    

    return (
      <Col xl={12}>
        
        {this.state.loading_overlay && (
          <LoadingOverlay active={true} spinner text="wertyui" />
        )}
        <Card>
          <CardBody style={{ paddingTop: 10, height: 140, paddingBottom: 12 }}>
           

            <form className="form form--inline" onSubmit={handleSubmit}>
              <div
                className="form__form-group col-xl-2"
                style={{ marginBottom: "0px" }}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  <select
                    className="form-control"
                    value={this.state.store_id}
                    style={{ fontSize: 13 }}
                    onChange={this.handleChange1}
                  >
                    <option value="">Select Group</option>
                    {this.state.store &&
                      this.state.store.length > 0 &&
                      this.state.store.map((store) => {
                        return (
                          <option value={store.id}> {store.name}</option>
                        );
                      })}
                  </select>
                </div>
              </div>

              <div
                className="form__form-group col-xl-2"
                style={{ marginBottom: "0px" }}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  <select
                    className="form-control"
                    value={this.state.store_id}
                    style={{ fontSize: 13 }}
                    onChange={this.handleSubgroupChange}
                  >
                    <option value="">Select SubGroup</option>
                    {this.state.subGroupList &&
                      this.state.subGroupList.length > 0 &&
                      this.state.subGroupList.map((store) => {
                        return (
                          <option value={store.id}> {store.name}</option>
                        );
                      })}
                  </select>
                </div>
              </div> 

               <div
                className="form__form-group col-xl-2"
                style={{marginBottom: "0px", display: 'none' }}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  <select
                    className="form-control"
                    value={this.state.store_id}
                    style={{ fontSize: 13 }}
                    onChange={this.ChangeOutlet}
                  >
                    <option value="">Select Area code</option>
                    {
                      this.state.areaCode.length > 0 &&
                      this.state.areaCode.map((store) => {
                        return (
                          <option value={store.area_code}> {store.area_code}</option>
                        );
                      })}
                  </select>
                </div>
              </div>


              <div
                className="form__form-group col-xl-2"
                style={{
                  display: "inline-block",
                  width: "100%",
                  marginBottom: "0px",
                  paddingTop:"2px",
                  
                }}
              >
                <DatePicker
                  selected={this.state.fromdate}
                  onChange={this.FromDateChange}
                  className="ledger_fromdate"
                  placeholderText="Bill From Date"
                  format="YYYY-MM-dd"
                  // style={{borderRadius:"5px"}}
                />
              </div>
              <div
                className="form__form-group col-xl-2"
                style={{
                  display: "inline-block",
                  width: "100%",
                  marginBottom: "0px",
                  paddingTop:"2px",
                 
                }}
              >
                <DatePicker
                  selected={this.state.todate}
                  onChange={this.ToDateChange}
                  className="ledger_todate"
                  placeholderText="Bill To Date"
                  format="YYYY-MM-dd"
                />
              </div>
              <div
                className="form__form-group col-xl-2"
                style={{ marginBottom: "0px",}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                   <input type = "text" className="form-control group_text_filter" placeholder= "Enter Area Code" onChange={this.onAreaCodeChange}/>
                </div>
              </div>
              <div
                className="form__form-group col-xl-2"
                style={{  marginBottom: "0px", height: 30 }}
              >
                <div
                  className="form__form-group-field"
                  style={{ display: "contents" }}
                >
                   <input style={{width: 100}} type = "text" className="form-control group_text_filter" placeholder= "Enter PL Group" onChange={this.onPLGroupChange}/>
                </div>
              </div>

              <div
                className="form__form-group col-xl-2"
                style={{ marginBottom: "0px", marginRight: 12, marginTop: 10 }}
              >
                <div
                  className="form__form-group-field"
                   
                >
                    <select
                    className="form-control"
                    value={this.state.store_id}
                    style={{ fontSize: 13 }}
                    onChange={this.onBillRangeChange}
                  >
                    <option value="">Select Bill Range</option>
                   
                    <option value="less"> {'<'}</option>
                    <option value="equal"> {'='} </option>
                    <option value="greater"> {'>'}</option>
            
                  </select>
                   {/*<input type = "text" className="form-control group_text1" placeholder= "Enter Bill Range" onChange={this.onBillRangeChange}/> */}
                </div>
              </div>

              <div
                className="form__form-group col-xl-2"
                style={{ display: "inline-block", marginBottom: "0px",  marginTop: 10 ,marginLeft:-9}}
              >
                <div
                  className="form__form-group-field"
                  style={{ display: "contents" }}
                >
                   <input type = "text" className="form-control group_text_filter" placeholder= "Enter Van " onChange={this.onVanFilterChange}/>
                </div>
              </div>

              <div
                className="form__form-group col-xl-2"
                style={{ display: "inline-block", marginBottom: "0px", marginRight: 5 , marginTop: 10 }}
              >
                <div
                  className="form__form-group-field"
                  style={{ display: "contents" }}
                >
                   <input type = "text" className="form-control group_text_filter" placeholder= "Enter Bill Value" onChange={this.onBillValueeChange}/>
                </div>
              </div>

              <div
                className="form__form-group col-xl-2"
                style={{ display: "inline-block", marginBottom: "0px", marginRight: 5, marginTop: 10 }}
              >
                <div
                  className="form__form-group-field"
                  style={{ display: "contents" }}
                >
                   <input type = "text" className="form-control group_text_filter" placeholder= "Enter Weight" onChange={this.onWeightChange}/>
                </div>
              </div>

              <div
                className="form__form-group col-xl-1"
                style={{ display: "inline-block", marginBottom: "0px", marginRight: 5,  marginTop: 10 ,width:5}}
              >
                <div
                  className="form__form-group-field"
                  style={{ display: "contents",width:10 }}
                >
                   <input type = "text" style={{width:120,borderRadius:"5px"}} placeholder= "Enter Volume" onChange={this.onVolumeChange}/>
                </div>
              </div>



              <div className="form__form-group col-xl-2" style={{marginLeft: 50, marginTop: 6}}>
                <ButtonToolbar className="form__button-toolbar">
                  <Button
                    className="btn-sm button_enable "
                    style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 5,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                      padding: "5px 20px",
                      marginLeft:"0px",
                      fontSize: "14px",
                    }}
                    id="button_enable"
                    onClick={() => this.fetchDispatch()}
                  >
                    {this.state.loading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "3px" }}
                      />
                    )}
                    Search
                  </Button>
                </ButtonToolbar>
              </div>
             
            </form>
          </CardBody>

          {this.state.showFetchDispatchData && (
            <CardBody style={{ marginTop: 10, paddingTop: 0, paddingBottom: 0 }}>
              
             <div
                className="dispatchData stock_check_data style_table"
                style={{ marginTop: 1 }}
              >

               <Button style={{marginBottom: 20,fontSize:12, marginTop:10, paddingTop: 5, paddingBottom:5, paddingLeft: 13, paddingRight: 13 , fontWeight: 'bold'}} variant="warning" onClick={(e) => this.OpenAssign1()}>Assign Van</Button>

               <Button style={{marginBottom: 20,fontSize:12, marginTop:10, paddingTop: 5, paddingBottom:5, paddingLeft: 13, paddingRight: 13 , fontWeight: 'bold'}} variant="warning" onClick={(e) => this.toggle2()}>Review</Button>
                
                <span style={{marginBottom: 20, marginTop:10, paddingTop: 5, paddingBottom:5, paddingLeft: 1, paddingRight: 10 , fontWeight: 'bold', fontSize :13}}> Selected Bill(s): {this.state.totalBillVal} </span>
                <span style={{ fontSize :13, marginBottom: 20, marginTop:10, paddingTop: 5, paddingBottom:5, paddingLeft: 3, paddingRight: 6, fontWeight: 'bold'}}> Value(s): {this.state.totalTonnage} </span>
                <span style={{marginBottom: 20,fontSize :13, marginTop:10, paddingTop: 5, paddingBottom:5, paddingLeft: 3, paddingRight: 6, fontWeight: 'bold'}}> Tonnage(kg): {this.state.totalWeightVal} </span>
                <span style={{marginBottom: 20, marginTop:10,fontSize :13, paddingTop: 5, paddingBottom:5, paddingLeft: 3, paddingRight: 6, fontWeight: 'bold'}}> Inner(Qty): {this.state.total_cld} </span>
                <span style={{marginBottom: 20, marginTop:10, paddingTop: 5,fontSize :13, paddingBottom:5, paddingLeft: 3, paddingRight: 15 , fontWeight: 'bold'}}> Each(Qty): {this.state.total_loose} </span>
                <MDBDataTable
                  scrollX
                  scrollY
                  maxHeight="390px"
                  searching={false}
                  displayEntries={false}
                   paging= {false}
                    sortable={false}
                  striped
                  bordered
                  data={dispatchData}
                />


              </div>
                      
            </CardBody>
          )}
        </Card>

         <Modal isOpen={modalNew} backdrop="static" toggle={this.toggleNew}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggleNew}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />
            <h6>{this.state.success_message} </h6>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.toggleOKNew}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={modal} backdrop="static" toggle={this.toggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />
            <h6>{this.state.success_message} </h6>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.toggleOK}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={modalFailed} backdrop="static" toggle={this.toggleFailed}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggleFailed}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />
            <h4>{this.state.failed_message} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.toggleFailedCancel}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

          <Modal isOpen={Failedmodal} backdrop="static" toggle={this.Failedtoggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-cross-circle modal__title-icon"
              style={{ color: "red" }}
            />
            <h4>{this.state.failed_message} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.Failedtoggle}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal
          isOpen={modal1}
          backdrop="static"
          toggle={this.toggle1}
          style={{ maxWidth: 1075, height: 500, padding: 0 }}
        >
          <div className="modal__header" style={{ backgroundColor: "#70bbfd" }}>
            <h4
              className="text-modal  modal__title"
              style={{ color: "#fff", paddingTop: 10 }}
            >
              Bill List
            </h4>
          </div>
          <div className="modal__body modal_table" style={{ marginTop: 10, padding: 10 }}>
            <MDBDataTable
                  scrollX
                  scrollY
                  maxHeight="350px"
                  displayEntries={false}
                  sortable={false}
                   paging= {false}
                  searching={false}
                  striped
                  bordered
                  data={dispatchData1}
                />

                

            <div style={{ width: "100%", float: "left", marginTop: 20 }}>
              <ButtonToolbar className="modal__footer">
                <button
                  className="modal_cancel"
                  onClick={this.toggleNPICancel}
                >
                  Cancel
                </button>

                <Button
                  style={{
                    backgroundColor: "#24d6a3",
                    color: "#fff",
                    marginLeft: 12,
                  }}
                  className="modal_ok"
                  disabled={this.state.disable_submit_button}
                  onClick={(e)=>this.OpenAssign()}
                >
                  {this.state.ShowConfirmLoader && (
                    <i
                      className="fa fa-refresh fa-spin"
                      style={{ marginRight: "5px" }}
                    />
                  )}
                  Assign Van
                </Button>
              </ButtonToolbar>
            </div>
          </div>
        </Modal>

        <Modal
          isOpen={modal2}
          toggle={this.toggle2}

          style={{ maxWidth: 1000, height: 500, padding: 0 }}
        >
          <div className="modal__header" style={{ backgroundColor: "#70bbfd" }}>
            <h4
              className="text-modal  modal__title"
              style={{ color: "#fff", paddingTop: 10 }}
            >
              Review Data
            </h4>
          </div>
          <div className="modal__body" style={{ marginTop: 10, padding: 16 }}>
            <div
              className="req_type"
              style={{
                width: "100%",
                float: "left",
                paddingBottom: 12,
                borderBottomWidth: 1,
                borderColor: "#ccc",
              }}
            >
                        
                    
            </div>   

            {this.state.apply1 && (
              <div style={{ width: "100%", float: "left" }}>
                <span style={{color: 'red'}}>{this.state.reviewErr}</span>
                <PaginationTable />
                {/* <table
                  className="table table-bordered table-hover"
                  id="tab_logic"
                >
                  <thead style={{ textAlign: "left" }}>
                    <tr>

                      <th>Van Name</th>
                      <th>Total Bill</th>
                      <th>Total Values </th>
                      <th>Total Weight </th>
                      <th>Location </th>
                    
                      
                    </tr>
                  </thead>
                  <tbody>
                      {this.state.reviewData.length > 0 &&
                        this.state.reviewData.map((item, index) => (
                          <tr>
                            <td>{item.van_name}</td>
                            <td>{item.total_bills}</td>
                            <td>{item.total_values}</td>
                            <td>{item.total_weight}</td>
                            <td><a href="/view_map" onClick={()=> localStorage.setItem("selected_van",item.van_name)}>View Map</a></td>
                    
                            </tr>
                        ))}

                    
                  </tbody>
                </table> */}
            
              </div>
            )}

            <div style={{ width: "100%", float: "left", marginTop: 12 }}>
              <ButtonToolbar className="modal__footer">
                <Button
                  style={{ backgroundColor: "#ddd", color: "#fff" }}
                  className="modal_ok"
                  onClick={this.toggle2}
                >
                  Cancel
                </Button>

                <Button
                  style={{
                    backgroundColor: "#24d6a3",
                    color: "#fff",
                    marginLeft: 12,
                  }}
                  className="modal_ok"
                  disabled={this.state.disable_submit_button}
                  // onClick={this.onConfirmProduct}
                  onClick={this.onConfirmProduct}
                >
                  {this.state.ShowEditLoader && (
                    <i
                      className="fa fa-refresh fa-spin"
                      style={{ marginRight: "5px" }}
                    />
                  )}
                  Confirm
                </Button>
              </ButtonToolbar>
            </div>
          </div>
        </Modal>

        <Modal isOpen={SuccessConfirmmodal} backdrop="static" toggle={this.SuccessConfirmtoggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.SuccessConfirmtoggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr  modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />
            <h5 style={{width: '70%'}}>Enter Van Name: </h5>
            

           
            
            <div style={{marginTop: 6, width: '86%'}}>
                <input type = "text"  className="form-control group_text1" placeholder= "Enter Van Name" onChange={this.handleChangeVan1Val} />
              
            </div>
            
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
                  style={{ backgroundColor: "#ddd", color: "#fff", marginRight: 8 }}
                  className="modal_ok"
                  onClick={this.SuccessConfirmtoggle}
                >
                  Cancel
                </Button>

            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.AssignData}
              disabled={this.state.assignDisabled}
            >
            {this.state.assignLoader && (
              <i
                className="fa fa-refresh fa-spin"
                style={{ marginRight: "5px" }}
              />
            )}
              Assign
            </Button>
          </ButtonToolbar>
        </Modal>

         <Modal isOpen={SuccessConfirmmodal1} backdrop="static" toggle={this.SuccessConfirmtoggle1}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.SuccessConfirmtoggle1}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr  modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />
            <h5 style={{width: '70%'}}>Enter Van Name: </h5>
            

           
            
            <div style={{marginTop: 6, width: '86%'}}>
                <input type = "text" className="form-control group_text1" placeholder= "Enter Van Name" onChange={this.handleChangeVanVal}/>
              
            </div>
            
          </div>
          <ButtonToolbar className="modal__footer">
            <button
                  style={{marginRight: 8 }}
                  className="modal_cancel"
                  onClick={this.SuccessConfirmtoggle1}
                >
                  Cancel
                </button>

            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.AssignData1}
              disabled={this.state.assignDisabled1}
            >
            {this.state.assignLoader1 && (
              <i
                className="fa fa-refresh fa-spin"
                style={{ marginRight: "5px" }}
              />
            )}
              Assign
            </Button>
          </ButtonToolbar>
        </Modal>
        <Modal isOpen={SuccessConfirmmodal2} backdrop="static" toggle={this.SuccessConfirmtoggle2}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.SuccessConfirmtoggle2}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr  modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />
            <h5 style={{width: '70%'}}>Enter Van Name: </h5>
            

           
            
            <div style={{marginTop: 6, width: '86%'}}>
                <input type = "text" className="form-control group_text1" placeholder= "Enter Van Name" onChange={this.handleChangeVanVal}/>
              
            </div>
            
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
                  style={{ backgroundColor: "#ddd", color: "#fff", marginRight: 8 }}
                  className="modal_ok"
                  onClick={this.SuccessConfirmtoggle2}
                >
                  Cancel
                </Button>

            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.onConfirmProduct}
              disabled={this.state.assignDisabled1}
            >
            {this.state.assignLoader1 && (
              <i
                className="fa fa-refresh fa-spin"
                style={{ marginRight: "5px" }}
              />
            )}
              Assign
            </Button>
          </ButtonToolbar>
        </Modal>
        
       
      </Col>
    );
  }
}

export default reduxForm({
  form: "Upload Master", // a unique identifier for this form
})(withTranslation("common")(HorizontalForm));